module.exports = __webpack_public_path__ + "static/media/logo_TIM.971e53a7.png";